import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export default function Card({ children, className = '', hover = false }: CardProps) {
  const hoverStyles = hover 
    ? 'hover:-translate-y-2 hover:shadow-[0_12px_24px_rgba(198,16,230,0.15)] transition-all duration-300' 
    : '';
  
  return (
    <div className={`bg-white rounded-2xl shadow-md p-6 ${hoverStyles} ${className}`}>
      {children}
    </div>
  );
}
